export default __webpack_public_path__ + "dropdown-icon.svg";